<div class="viewport-1" [style.background-image]="'url(' + taskBackgroundImage + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="taskTotalPoints"></task-bar>
  @if (animationComplete || !animateContainer) {
    <div class="task-screen-element fill-in-blank-container" [style.background-image]="' ' + taskContainerColor + ' '">
      <div class="testType font-18">{{ testType }}</div>
      <div class="timer-bar-container">
        <trial-timer-bar></trial-timer-bar>
        <button [class]="(hideTimer) ? 'replayVideo-no-timerbar' : 'replayVideo'" (click)="replayVideo()" [disabled]="disableAVButtons"></button>
      </div>
      <div [class]="{'find-the-word-syllables-target-area' : findTheSyllableBreaksTask,'find-the-word-syllables-target-area-no-border' : !findTheSyllableBreaksTask}">
        <div class="audio-controls-container">
          <button
            class="speaker"
            [class.find-the-syllables-speaker-adjust]="findTheSyllableBreaksTask"
            (click)="playTargetAudioViaSpeakerClick($event)" [disabled]="disableAVButtons">
          </button>
          <button class="snail-button" (click)="playTargetAudioViaSpeakerClickSlowed($event)" [disabled]="disableAVButtons"></button>
        </div>
        @if (findTheSyllableBreaksTask) {
          <div class="find-the-word-syllables-target-text font-42">{{targetWord}}</div>
        }
      </div>
      @if (responseOptions1.length > 0) {
        <div class="find-the-word-syllables-response-row">
          @for (response of responseOptions1; track response.text) {
            <div class="big-button-div">
              <button class = "big-div-letter-audio-hidden" [hidden]="showResponseAudioButtons"></button>
              <button class = "big-div-letter-audio" [hidden]="!showResponseAudioButtons" (click)="playResponseAudio(response.index)" [disabled]="disableAVButtons"></button>
              <button
                class = "syllable-breaks-response-block font-30"
                [class.hover]="response.highlight"
                [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
                [disabled]="responsesDisabled"
                (click)="submitResponse(response.index);"
                >
                {{response.text}}
                <span class="find-the-word-family-text-color">{{response.wordFamily}}</span>
              </button>
            </div>
          }
        </div>
      }
      @if (responseOptions2.length > 0) {
        <div class="find-the-word-syllables-response-row">
          @for (response of responseOptions2; track response.text) {
            <div class="big-button-div">
              <button class = "big-div-letter-audio-hidden" [hidden]="showResponseAudioButtons"></button>
              <button class = "big-div-letter-audio" [hidden]="!showResponseAudioButtons" (click)="playResponseAudio(response.index)" [disabled]="disableAVButtons"></button>
              <button
                class = "syllable-breaks-response-block font-30"
                [class.hover]="response.highlight"
                [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
                [disabled]="responsesDisabled"
                (click)="submitResponse(response.index);"
                >
                {{response.text}}
                <span class="find-the-word-family-text-color">{{response.wordFamily}}</span>
              </button>
            </div>
          }
        </div>
      }
      @if (responseOptions3.length > 0) {
        <div class="find-the-word-syllables-response-row">
          @for (response of responseOptions3; track response.text) {
            <div class="big-button-div">
              <button class="big-div-letter-audio-hidden" [hidden]="showResponseAudioButtons"></button>
              <button class="big-div-letter-audio" [hidden]="!showResponseAudioButtons" (click)="playResponseAudio(response.index)" [disabled]="disableAVButtons"></button>
              <button
                class="syllable-breaks-response-block font-30"
                [class.hover]="response.highlight"
                [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
                [disabled]="responsesDisabled"
                (click)="submitResponse(response.index)"
                >
                {{response.text}}
                <span class="find-the-word-family-text-color">{{response.wordFamily}}</span>
              </button>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
</div>
